import { ChangeEvent, useEffect, useRef, useState } from "react";
import { getAuth, updateProfile, createUserWithEmailAndPassword, onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../service";
import { Link, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Card } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

export default function RegisterPageDisplay() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [name, setName] = useState("");

    const [passwordError, setPasswordError] = useState(false);
    const navigate = useNavigate();

    function handleSignIn() {
        if(password !== confirmPassword) return setPasswordError(true);

        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in
                if(auth.currentUser !== null) updateProfile(auth.currentUser, {
                    displayName: name, photoURL: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" 
                  }).then(() => {
                    alert("usuário criado com sucesso.")
                    
                  }).catch((error) => {
                    console.error(error)
                  });
                
                navigate('/minhas-listas');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error(errorCode, errorMessage);
            });

    }

    return (
        <>
            <Card style={{ width: '20rem', margin: '0 auto', marginTop: '2rem', marginBottom: '2rem' }}>
                <Card.Body>
                    <Card.Title>Crie sua conta:</Card.Title>
                    <Form onSubmit={e => {
                        e.preventDefault();
                        handleSignIn();
                    }}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Endereço de e-mail:</Form.Label>
                            <Form.Control  type="email" placeholder="Digite seu email" onChange={e => setEmail(e.target.value)} />
                            <Form.Text className="text-muted">
                                Jamais compartilharemos seu e-mail com ninguém.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Senha com pelo menos 6 caracteres</Form.Label>
                            <Form.Control type="password" placeholder="Digite sua senha" onChange={e => setPassword(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Confirme sua Senha</Form.Label>
                            <Form.Control type="password" placeholder="Digite sua senha" onChange={e => setConfirmPassword(e.target.value)} />
                        </Form.Group>
                            {passwordError && <p style={{color: "red"}}>As senhas não coincidem, por favor confirme a senha corretamente</p>} <br></br>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Nome do usuário</Form.Label>
                            <Form.Control type="text" placeholder="Digite seu nome" onChange={e => setName(e.target.value)} />
                        </Form.Group>
                        <Link to="/login">Já tenho uma conta</Link>
                        <Button variant="success" type="submit" style={{marginLeft: '1rem'}}>
                            Cadastrar
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

        </>
    );

} 